import { ExperienceEnum } from './enums/experience'

export const experienceMap = {
  [ExperienceEnum.YesLong]: 'Да, была длительная терапия',
  [ExperienceEnum.YesShort]: 'Да, было несколько сессий',
  [ExperienceEnum.No]: 'Нет'
}
